export const rewards = {
  appBarTitle: "الجوائز",
  addReward: "أضف جائزة جديدة",
  table: {
    points: "النقاط المطلوبة",
    level: "المستوى",
    reward: "نوع الجائزة",
    status: "الحالة",
    expiryDate: "تاريخ انتهاء الصلاحية",
    totalNumber: "إجمالى عدد السائقين",
    totalEarned: "السائقين المستحقين",
    totalRedeemed: "المكتسبين",
    voucher: "قسيمة",
    discount: "خصم",
    chargingCard: "كارت شحن",
    active: "نشط",
    inactive: "غير نشط",
    expired: "منتهي الصلاحية",
    rewardAmount: "مبلغ الجائزة",
    rewardCreationDate: "تاريخ الإنشاء",
    rewardDeletionDate: "تاريخ الحذف",
    numberQualifiedEarned: "السائقين المؤهلين المكتسبين",
    numberUserSelected: "المختارين",
    numberExpiredRewards: "منتهية الصلاحية",
  },
  filters: {
    reward: "نوع الجائزة",
    status: "الحالة",
    points: "النقاط المطلوبة",
    level: "المستوى",
    voucher: "قسيمة",
    discount: "خصم",
    chargingCard: "كارت شحن",
    active: "نشط",
    inactive: "غير نشط",
    expired: "منتهي الصلاحية",
  },
  rewardsForm: {
    addTitle: "إضافة جائزة",
    editTitle: "تعديل جائزة",
    rewardPhoto: "صورة الجائزة",
    requiredPoints: "النقاط المطلوبة",
    rewardType: "نوع الجائزة",
    voucher: "قسيمة",
    discount: "خصم",
    chargingCard: "كارت شحن",
    voucherAmount: "مبلغ القسيمة",
    chargingCardAmount: "مبلغ كارت الشحن",
    discountPercentage: "قيمة الخصم",
    rewardValue: "قيمة الجائزة",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    validations: {
      statusRequired: "الحالة مطلوبة",
      pointsRequired: "النقاط المطلوبة مطلوبة",
      pointsOnlyNumbers: "النقاط المطلوبة تقبل أرقام صحيحة فقط",
      pointsMoreThanZero: "يجب أن تكون النقاط المطلوبة أكبر من 0",
      rewardTypeRequired: "نوع الجائزة مطلوب",
      voucherAmountRequired: "مبلغ القسيمة مطلوب",
      voucherAmountOnlyNumbers: "مبلغ القسيمة يقبل أرقام صحيحة فقط",
      voucherAmountMoreThanZero: "يجب أن يكون مبلغ القسيمة أكبر من 0",
      chargingCardAmountRequired: "مبلغ كارت الشحن مطلوب",
      chargingCardAmountOnlyNumbers: "مبلغ كارت الشحن يقبل أرقام صحيحة فقط",
      chargingCardAmountMoreThanZero: "يجب أن يكون مبلغ كارت الشحن أكبر من 0",
      discountPercentageRequired: "قيمة الخصم مطلوبة",
      discountPercentageOnlyNumbers: "قيمة الخصم تقبل أرقام صحيحة فقط",
      discountPercentageMoreThanZero: "يجب أن تكون قيمة الخصم بين 0 و 100 ",
    },
    offersLocale: {
      maxValue: "الحد الأقصى: ",
      from: "من: ",
      to: "إلى: ",
      percent: "%",
      egp: "ج.م",
    },
  },
  rewardDetails: {
    title: "تفاصيل العرض",
    requiredPoints: "النقاط المطلوبة",
    rewardType: "نوع الجائزة",
    level: "المستوى",
    voucher: "قسيمة",
    discount: "خصم",
    chargingCard: "كارت شحن",
    voucherAmount: "مبلغ القسيمة",
    chargingCardAmount: "مبلغ كارت الشحن",
    discountPercentage: "قيمة الخصم",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    expired: "منتهي الصلاحية",
    expiryDate: "تاريخ انتهاء الصلاحية",
    editStatusTitle: "تعديل حالة الجائزة",
    editStatusDescription: "هل أنت متأكد أنك تريد تغيير حالة الجائزة إلى ",
    deleteRewardTitle: "حذف الجائزة",
    deleteRewardDescription: "هل أنت متأكد أنك تريد حذف الجائزة ؟",
    deleteRewardPhotoTitle: "حذف صورة الجائزة",
    deleteRewardPhotoDescription: "هل أنت متأكد أنك تريد حذف صورة الجائزة ؟",
    exportRewardingReport: "تحميل تقرير الجائزة",
    exportRewardingReportMsg:
      "هل أنت متأكد أنك تريد تحميل جميع تفاصيل الجائزة؟",
    reportExcelHeaders: {
      number: "الرقم",
      milestone: "الحدث الرئيسي (النقاط المطلوبة)",
      milestoneType: "نوع الحدث الرئيسي",
      rewardType: "نوع الجائزة",
      amount: "المبلغ",
      status: "الحالة",
      totalDriversEarned: "إجمالى السائقين المستحقين",
      totalDriversQualified: "إجمالى السائقين المؤهلين",
      totalDriversRedeemed: "إجمالى السائقين المكتسبين",
      totalAmount: "إجمالى المبلغ",
    },
  },
  messages: {
    rewardAdded: "تم إضافة الجائزة بنجاح",
    rewardEdited: "تم تعديل الجائزة بنجاح",
    rewardDeleted: "تم حذف الجائزة بنجاح",
  },
};
